import React from 'react'
import { Link } from 'react-router-dom'
import { FormGroup, FormText, Label } from 'reactstrap'

export default function FieldsetItem(props) {
  const className = `mb-0 ${
    props.color ? `alert alert-${props.color} pt-0 pb-0` : ''
  }`
  const isLink = props.data && !!props.url
  const content = props.data ? props.data : props.children
  const labelContent = toString(content)

  return (
    <FormGroup
      className={`${className} ${props.className}`}
      style={props.style}
    >
      <FormText>{props.title}:</FormText>
      {isLink && (
        <Label>{isLink && <Link to={props.url}>{props.data}</Link>}</Label>
      )}
      {!isLink && <Label>{labelContent}</Label>}
    </FormGroup>
  )
}

const toString = data => {
  if (typeof data === 'boolean') return data ? 'True' : 'False'
  return data
}
